export default __webpack_public_path__ + "static/10km-runs-f3259d508699068d41877c385b4704ba.webp";